import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import useToast from '../hooks/useToast';
import ToastContainer from '../components/ToastContainer';

const InventoryPage = () => {
  const [stats, setStats] = useState({
    total: 0,
    active: 0,
    maintenance: 0,
    inactive: 0
  });
  const { toasts, removeToast } = useToast();

  // API çağrıları

  const fetchStats = async () => {
    try {
      const response = await api.getInventoryStats();
      if (response.success && response.data) {
        setStats(response.data);
      }
    } catch (error) {
      console.error('İstatistikler yüklenirken hata:', error);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  // getStatusColor function removed as it's not used

  return (
    <div className="modern-hr-page">
      <div className="container-fluid">
        <div className="modern-hr-header">
          <div className="modern-hr-header-content">
            <div className="modern-hr-header-text">
              <h1>Zimmet Yönetimi</h1>
              <p>Şirket malzemelerinin zimmet takibi ve yönetimi</p>
            </div>
            <div className="modern-hr-header-actions">
              <div className="modern-hr-stats">
                <div className="modern-hr-stat-item">
                  <i className="bx bx-package"></i>
                  <span>{stats.total} Zimmet</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Genel İstatistikler */}
        <div className="row mb-4">
          <div className="col-lg-3 col-md-6 mb-3">
            <div className="modern-stats-card">
              <div className="modern-stats-card-icon bg-primary">
                <i className="bx bx-package"></i>
              </div>
              <div className="modern-stats-card-content">
                <h3>{stats.total}</h3>
                <p>Toplam Zimmet</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 mb-3">
            <div className="modern-stats-card">
              <div className="modern-stats-card-icon bg-success">
                <i className="bx bx-check-circle"></i>
              </div>
              <div className="modern-stats-card-content">
                <h3>{stats.active}</h3>
                <p>Aktif</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 mb-3">
            <div className="modern-stats-card">
              <div className="modern-stats-card-icon bg-warning">
                <i className="bx bx-wrench"></i>
              </div>
              <div className="modern-stats-card-content">
                <h3>{stats.maintenance}</h3>
                <p>Bakımda</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 mb-3">
            <div className="modern-stats-card">
              <div className="modern-stats-card-icon bg-danger">
                <i className="bx bx-x-circle"></i>
              </div>
              <div className="modern-stats-card-content">
                <h3>{stats.inactive}</h3>
                <p>Pasif</p>
              </div>
            </div>
          </div>
        </div>

        {/* Hızlı Erişim */}
        <div className="row">
          <div className="col-lg-4 col-md-6 mb-4">
            <div className="modern-hr-widget">
              <div className="modern-hr-widget-header">
                <div className="modern-hr-widget-title">
                  <i className="bx bx-list-ul"></i>
                  <h4>Zimmet Listesi</h4>
                </div>
              </div>
              <div className="modern-hr-widget-body">
                <p>Tüm zimmet kayıtlarını görüntüleyin, düzenleyin ve yönetin.</p>
                <Link to="/zimmet-listesi" className="modern-hr-btn modern-hr-btn-primary">
                  <i className="bx bx-list-ul"></i>
                  Listeyi Görüntüle
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mb-4">
            <div className="modern-hr-widget">
              <div className="modern-hr-widget-header">
                <div className="modern-hr-widget-title">
                  <i className="bx bx-plus"></i>
                  <h4>Yeni Zimmet</h4>
                </div>
              </div>
              <div className="modern-hr-widget-body">
                <p>Yeni zimmet kaydı oluşturun ve sisteme ekleyin.</p>
                <Link to="/yeni-zimmet" className="modern-hr-btn modern-hr-btn-success">
                  <i className="bx bx-plus"></i>
                  Yeni Kayıt
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mb-4">
            <div className="modern-hr-widget">
              <div className="modern-hr-widget-header">
                <div className="modern-hr-widget-title">
                  <i className="bx bx-bar-chart"></i>
                  <h4>Raporlar</h4>
                </div>
              </div>
              <div className="modern-hr-widget-body">
                <p>Zimmet istatistikleri ve analiz raporlarını görüntüleyin.</p>
                <Link to="/zimmet-raporlari" className="modern-hr-btn modern-hr-btn-info">
                  <i className="bx bx-bar-chart"></i>
                  Raporları Görüntüle
                </Link>
              </div>
            </div>
          </div>
        </div>


      </div>

      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </div>
  );
};

export default InventoryPage;
